import { StateCreator } from 'zustand'
import { Store } from '../type'

type NavigationSlice = Pick<
  Store,
  'currentPath' | 'previousPath' | 'setCurrentPath'
>
export const navigationSlice: StateCreator<Store, [], [], NavigationSlice> = (
  set,
  get,
) => ({
  previousPath: null,
  currentPath: '/',
  setCurrentPath: (path) => {
    if (path === get().currentPath) {
      return
    }

    get().removeBanner()
    set((state) => {
      return { previousPath: state.currentPath, currentPath: path }
    })
  },
})
